<template>
  <!-- eslint-disable  max-len -->

  <div class="site__container">
    <main class="page__content" style="min-height: 836px">
      <div class="site__inner">
        <div class="signin__container">
          <div class="signin__form">
            <!-- /.form__step__section -->
            <div
              class="form__step form__step--login"
              :class="{
                'form__step--active': page === PAGE.LOGIN,
              }"
            >
              <header class="form__header">
                <h3
                  class="form__heading form__heading--strikethrough group wt2-sg"
                >
                  <span class="wt2-text-2xl">Sign In to Wochit</span>
                </h3>
                <span class="wt2-text-s sub-title">{{ host }}</span>
                <!-- /.form__content -->
              </header>
              <!-- /.form__header -->
              <div class="form__step__section__container group">
                <div class="form__step__section form__step__section--manual">
                  <form
                    novalidate="true"
                    class="form--login"
                    method="post"
                    @submit="onSignIn"
                  >
                    <div class="form__fields group">
                      <div
                        class="form__field form__field--has_value"
                        :class="{
                          'form__field--flash':
                            errors.email || errors.forbidden || errors.password,
                        }"
                      >
                        <input
                          class="form__field__input--email form__field__input--email_required"
                          type="email"
                          name="email"
                          v-model="email"
                          id="login_email"
                          placeholder="Email"
                        />
                        <small
                          v-if="errors.email"
                          class="form__field__error__message"
                          >Valid Email Required</small
                        >
                        <small
                          v-if="errors.forbidden"
                          class="form__field__error__message"
                          >Incorrect Login</small
                        >
                      </div>

                      <div
                        class="form__field form__field--has_value"
                        :class="{
                          'form__field--flash':
                            errors.password || errors.forbidden,
                        }"
                      >
                        <input
                          class="form__field__input--password"
                          autocomplete="off"
                          v-model="password"
                          type="password"
                          name="password"
                          id="login_password"
                          maxlength="255"
                          placeholder="Password"
                        />
                        <small
                          v-if="errors.password"
                          class="form__field__error__message"
                          >Valid Password Required</small
                        >
                      </div>
                    </div>
                    <!-- /.form__fields -->
                    <div class="form__actions">
                      <button
                        :disabled="isPending"
                        type="submit"
                        class="btn btn--submit"
                        data-login-label="Sign In"
                        data-signup-label="Contact Us"
                      >
                        <span class="btn__content">Sign In</span>
                      </button>
                      <div class="form__forgot">
                        <a @click="CHANGE_PAGE(PAGE.FORGOT)"
                          >Forgot password?</a
                        >
                      </div>
                    </div>
                    <!-- /.form__actions -->
                  </form>
                  <!-- /.form -->
                </div>
                <!-- /.form__step__section -->
              </div>
              <!-- /.form__step__section__container -->
            </div>
            <!-- /.form__step -->
            <div
              class="form__step form__step--forgot form__step--fixed_button"
              :class="{
                'form__step--active': page === PAGE.FORGOT,
              }"
            >
              <header class="form__header">
                <h3 class="form__heading form__heading--strikethrough">
                  <span>Password Reset</span>
                </h3>
                <div class="form__content">
                  <p>
                    Enter your email address and we'll send you a secure link to
                    reset your password.
                  </p>
                </div>
                <!-- /.form__content -->
              </header>
              <!-- /.form__header -->
              <form
                autocomplete="off"
                novalidate=""
                class="form--reset_email"
                @submit="onForgot"
              >
                <div class="form__step__vc">
                  <div
                    class="form__fields group"
                    :class="{
                      'form__field--flash': errors.email || errors.forbidden,
                    }"
                  >
                    <div class="form__field">
                      <input
                        v-model="email"
                        class="form__field__input--text form__field__input--email"
                        type="email"
                        name="resetEmail"
                        id="resetEmail"
                        placeholder="Email"
                      />
                      <small
                        v-if="errors.email"
                        class="form__field__error__message"
                        >Valid Email Required</small
                      >
                      <small
                        v-if="errors.forbidden"
                        class="form__field__error__message"
                        >Email not found</small
                      >
                    </div>
                  </div>
                  <!-- /.form__fields -->
                </div>
                <!-- /.form__step__vc -->
                <div class="form__actions">
                  <button
                    :disabled="isPending"
                    type="submit"
                    class="btn btn--submit"
                  >
                    <span class="btn__content">Send a Reset Email</span>
                  </button>
                </div>
                <!-- /.form__actions -->
              </form>
              <footer class="form__footer">
                <a class="form__forgot__back" @click="CHANGE_PAGE(PAGE.LOGIN)"
                  >Back to Login</a
                >
              </footer>
              <!-- /.form__footer -->
            </div>
            <!-- /.form__step -->
            <div
              class="form__step form__step--forgot_sent"
              :class="{
                'form__step--active': page === PAGE.FORGOT_SEND,
              }"
            >
              <header class="form__header">
                <h3 class="form__heading form__heading--strikethrough">
                  <span>Email Sent</span>
                </h3>
              </header>
              <!-- /.form__header -->
              <div class="form__content">
                <div class="form__content__body">
                  <h3>Thank You</h3>
                  <p>
                    If your email has a wochit account you'll be receiving
                    instructions on how to reset your password in just a moment.
                  </p>
                </div>
                <!-- /.form__content__body -->
              </div>
              <!-- /.form__content -->
              <footer class="form__footer">
                <a
                  class="form__forgot_sent__back"
                  @click="CHANGE_PAGE(PAGE.LOGIN)"
                  >Back to Login</a
                >
              </footer>
              <!-- /.form__footer -->
            </div>
            <!-- /.form__step -->
            <div
              class="form__step form__step--change_password"
              :class="{
                'form__step--active': page === PAGE.RESET_PASSWORD,
              }"
            >
              <header class="form__header">
                <h3 class="form__heading form__heading--strikethrough">
                  <span>Choose a New Password</span>
                </h3>
              </header>
              <!-- /.form__header -->

              <div class="form__content">
                <form class="form--change_password" @submit="onResetPassword">
                  <div
                    class="form__fields group"
                    :class="{
                      'form__field--flash': errors.password,
                    }"
                  >
                    <div class="form__field">
                      <input
                        class="form__field__input--password"
                        autocomplete="off"
                        v-model="password"
                        type="password"
                        name="password"
                        maxlength="255"
                        placeholder="Password"
                      />
                      <small class="form__field__error__message"
                        >Valid Password Required</small
                      >
                    </div>
                  </div>
                  <!-- /.form__fields -->
                  <div class="form__actions">
                    <button
                      :disabled="isPending"
                      type="submit"
                      class="btn btn--submit"
                    >
                      <span class="btn__content">Update Password</span>
                    </button>
                  </div>
                  <!-- /.form__actions -->
                </form>
              </div>
              <!-- /.form__content -->
            </div>
            <!-- /.form__step -->
            <div
              class="form__step form__step--change_password_confirmation"
              :class="{
                'form__step--active': page === PAGE.RESET_PASSWORD_DONE,
              }"
            >
              <header class="form__header">
                <h3 class="form__heading form__heading--strikethrough">
                  <span>Password Updated</span>
                </h3>
              </header>
              <!-- /.form__header -->
              <div class="form__content">
                <p>
                  Please <a @click="CHANGE_PAGE(PAGE.LOGIN)">sign in</a> to
                  Wochit with your email and new password.
                </p>
              </div>
              <!-- /.form__content -->
              <!-- /.form__footer -->
            </div>
            <!-- /.form__step -->

            <div
              class="form__step form__step--foobar"
              :class="{
                'form__step--active': page === PAGE.BROWSER_NOT_SUPPORTED,
              }"
            >
              <div class="signin__unsupported__container">
                <div class="signin__unsupported">
                  <div class="signin__unsupported__image"></div>
                  <!-- /.signin__unsupported__image -->

                  <div class="signin__unsupported__copy copy__body">
                    <h3 style="text-align: center">Browser is not supported</h3>
                    <p style="text-align: center">
                      Wochit works on Google Chrome, see you there!
                    </p>
                    <p style="text-align: center">
                      <a
                        href="https://www.google.com/chrome/"
                        target="_blank"
                        rel="noopener"
                        >Download Chrome</a
                      >
                    </p>
                  </div>
                  <!-- /.signin__unsupported__copy -->
                </div>
                <!-- /.signin__unsupported -->
              </div>
            </div>
          </div>

          <!-- /.signin__form -->
          <div class="signin__news" v-if="showChannelBanner">
            <div class="logos">
              <div class="logo">
                <i class="wticon wticon-logo-icon" />
                <div>Wochit</div>
              </div>
              <div class="middle">
                <i class="wticon wticon-arrows-horizontal" />
              </div>
              <div class="logo">
                <img :src="channelLogo" />
                <div>{{ subDomain }}</div>
              </div>
            </div>
          </div>
          <!-- /.signin__news -->
        </div>

        <!-- /.signin__container -->
      </div>
      <!-- /.site__inner -->
    </main>
    <!-- /.page__content -->
  </div>
  <!-- /.site__container -->
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { PAGE } from '../enums';

export default {
  data: () => ({
    PAGE,
    email: '',
    password: '',
    tryLogin: false,
    errors: {
      email: false,
      forbidden: false,
      password: false,
    },
    host: location.host,
  }),

  watch: {
    password() {
      if (this.errors.password || this.errors.forbidden) {
        this.errors.password = false;
        this.errors.forbidden = false;
      }
    },
    email() {
      if (this.errors.forbidden || this.errors.email) {
        this.errors.email = false;
        this.errors.forbidden = false;
      }
    },
  },

  computed: {
    ...mapGetters([
      'isResetPassword',
      'wochitLogo',
      'channelLogo',
      'isPending',
      'page',
    ]),

    showChannelBanner() {
      return !!serverProfile.channelLogoUrl;
    },

    subDomain() {
      const match = location.hostname.match(/(.*?)\./);
      if (match) {
        return match[1];
      } else {
        return '';
      }
    },
  },

  methods: {
    ...mapActions(['login', 'forgot', 'resetPassword']),
    ...mapMutations(['CHANGE_PAGE']),

    validate({ password = false, email = true } = {}) {
      Object.keys(this.errors).forEach((key) => {
        this.errors[key] = false;
      });
      if (password && !this.password) {
        this.errors.password = true;
      }
      if (email && !this.validEmail(this.email)) {
        this.errors.email = true;
      }
      return !Object.entries(this.errors).reduce(
        (bool, [key, value]) => bool || value,
        false
      );
    },

    async onForgot(e) {
      e.preventDefault();
      if (this.validate()) {
        try {
          await this.forgot({ email: this.email });
        } catch (e) {
          this.errors.forbidden = true;
        }
      }
    },

    async onResetPassword(e) {
      e.preventDefault();
      if (this.validate({ email: false, password: true })) {
        try {
          await this.resetPassword({ password: this.password });
        } catch (e) {
          this.errors.forbidden = true;
        }
      }
    },

    async onSignIn(e) {
      e.preventDefault();
      if (this.validate({ password: true })) {
        const res = await this.login({
          email: this.email,
          password: this.password,
        });
        if (!res.token) {
          this.errors.forbidden = true;
        }
      }
    },

    validEmail: (email) => {
      // eslint-disable-next-line no-useless-escape
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
$logoSize: 60px;
.logos {
  color: rgba(0, 0, 0, 0.75);
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  margin: auto;
  font-size: 15px;
  width: 100%;
  display: grid;

  grid-row-gap: 25px;
  grid-template-columns: 43% 14% 43%;
  text-transform: capitalize;
  .wticon.wticon-logo-icon {
    font-size: $logoSize;
    color: #06a9f4;
    align-self: end;
  }
  .middle {
    display: flex;
    .wticon.wticon-arrows-horizontal {
      margin: 15px auto auto;
      font-size: 32px;
    }
  }
  img {
    height: $logoSize;
    max-width: 100%;
  }
  .logo {
    > div {
      margin-top: 15px;
    }
  }
}
</style>
